import { createAction } from 'redux-actions'

export const SET_CREDENTIALS = 'SET_CREDENTIALS'

export const setCredentials = createAction(SET_CREDENTIALS)
